import { Card, CardContent } from './ui/card';
import ShadowCostGraph from './ShadowCostGraph';

// Savings tab (Phase 1 — FinOps IA). Composes the existing ShadowCostGraph
// (self-fetches /clusters/{id}/shadow-cost) with month-to-date savings summary
// cards from the shared monitoring context. Purely additive; nothing new on the
// backend.

const num = (v, d = 2) => (typeof v === 'number' ? v.toFixed(d) : '—');

const card = (label, value, sub, accent) => (
  <Card className="border border-slate-200 dark:border-surface-border bg-white dark:bg-surface-dark shadow-sm">
    <CardContent className="p-5">
      <p className="text-xs font-medium uppercase tracking-wide text-slate-500 dark:text-text-secondary mb-2">{label}</p>
      <p className={`text-3xl font-semibold tabular-nums ${accent || 'text-slate-900 dark:text-white'}`}>{value}</p>
      {sub && <p className="text-xs text-slate-500 dark:text-text-secondary mt-1">{sub}</p>}
    </CardContent>
  </Card>
);

export default function SavingsPanel({ clusterId, mtdSavings, mtdSavingsPct, shadow }) {
  const sum = shadow?.summary || {};
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {card('MTD Savings', `$${num(mtdSavings)}`, 'realized month-to-date vs no-OptOps baseline', 'text-emerald-600 dark:text-emerald-400')}
        {card('Savings Rate', `${num(mtdSavingsPct, 1)}%`, 'of the shadow (un-optimized) spend')}
        {card('Shadow Spend (no OptOps)', sum.total_shadow != null ? `$${num(sum.total_shadow)}` : '—', `vs $${sum.total_actual != null ? num(sum.total_actual) : '—'} actual`)}
      </div>
      {/* Existing shadow what-if timeline graph (self-fetching) */}
      <ShadowCostGraph clusterId={clusterId} />
    </div>
  );
}
